import React from "react";
import {
	CustomButton,
	GenericDialog,
	GenericDialogContent,
	GenericDialogFooter,
	GenericDialogHeader,
} from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import styles from "./LogoDeleteDialog.module.css";

export default function LogoDeleteDialog({ open, mode, onClose, onConfirm }) {
	const isDeleteAll = mode === "all";

	const title = isDeleteAll
		? translate("admin.company-logo.delete-all-dialog.title")
		: translate("admin.company-logo.delete-dialog.title");

	const content = isDeleteAll
		? translate("admin.company-logo.delete-all-dialog.content")
		: translate("admin.company-logo.delete-dialog.content");

	return (
		<GenericDialog disableBackdropClick fullWidth maxWidth="xs" open={open} onClose={onClose}>
			<GenericDialogHeader>{title}</GenericDialogHeader>
			<GenericDialogContent>
				<div className={styles.content}>{content}</div>
			</GenericDialogContent>
			<GenericDialogFooter>
				<CustomButton color="secondary" variant="outlined" onClick={onClose}>
					{translate("common:btn.cancel")}
				</CustomButton>
				<CustomButton color="destructive" variant="contained" onClick={onConfirm}>
					{translate("common:btn.delete")}
				</CustomButton>
			</GenericDialogFooter>
		</GenericDialog>
	);
}
